<template>
    <span v-if="!selectedModeling" class="cr-spinner" />
    <div v-else>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="dimension in organizedDimensions[0].measurements">
                        <span class="hidden-xs-down">{{ dimension.label }}</span>
                        <span class="hidden-xs-up">{{ dimension.shortLabel }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(size, index) in organizedDimensions">
                    <td class="title">{{ size.name }}</td>
                    <td v-for="measurement in organizedDimensions[index].measurements">
                        {{ measurement.value }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'SizesTableV2',

        props: {
            selectedModeling: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {};
        },

        computed: {
            organizedDimensions() {
                let arr = [];

                this.selectedModeling.dimensions
                    .sort((a, b) =>
                        this.selectedModeling.sizes[parseInt(a.size_id)].order >=
                        this.selectedModeling.sizes[parseInt(b.size_id)].order
                            ? 1
                            : -1
                    )
                    .forEach((dimension) => {
                        // Crie um objeto para representar a dimensão
                        const dimensionObj = {
                            id: dimension.id,
                            measurements: [],
                            name: this.selectedModeling.sizes[dimension.size_id].name,
                            size_id: dimension.size_id,
                        };

                        if (dimension.height) {
                            dimensionObj.measurements.push({
                                label: 'Comprimento',
                                shortLabel: 'C',
                                value: dimension.height,
                            });
                        }

                        if (dimension.width) {
                            dimensionObj.measurements.push({
                                label: 'Largura',
                                shortLabel: 'L',
                                value: dimension.width,
                            });
                        }

                        if (dimension.length) {
                            dimensionObj.measurements.push({
                                label: 'Comprimento',
                                shortLabel: 'C',
                                value: dimension.length,
                            });
                        }

                        if (dimension.waist) {
                            dimensionObj.measurements.push({
                                label: 'Cintura',
                                shortLabel: 'Cint',
                                value: dimension.waist,
                            });
                        }

                        if (dimension.hip) {
                            dimensionObj.measurements.push({
                                label: 'Quadril',
                                shortLabel: 'Quadril',
                                value: dimension.hip,
                            });
                        }

                        if (dimension.sleeve_length) {
                            dimensionObj.measurements.push({
                                label: 'Manga',
                                shortLabel: 'M',
                                value: dimension.sleeve_length,
                            });
                        }

                        if (dimension.sleeve_circumference) {
                            dimensionObj.measurements.push({
                                label: 'Circunf.',
                                shortLabel: 'Circ',
                                value: dimension.sleeve_circumference,
                            });
                        }

                        if (dimension.leg_circumference) {
                            dimensionObj.measurements.push({
                                label: 'Circunf. Perna',
                                shortLabel: 'Circ Perna',
                                value: dimension.leg_circumference,
                            });
                        }
                        // Depois de processar todas as labels da dimensão, adicione o objeto da dimensão ao array
                        arr.push(dimensionObj);
                    });

                // Agora, vamos extrair todas as measurements de cada objeto do array arr
                // Retornar o array com todas as measurements
                return arr.map((dimensionObj) => dimensionObj);
            },
        },
    };
</script>
